import {
  jssPreset,
  StylesProvider, Theme,
  ThemeProvider
} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import StyledEngineProvider from "@material-ui/core/StyledEngineProvider";
import theme from "./themes";
import Routes from "./routes";
import Snackbar from "./ui-component/extended/Snackbar";
import NavigationScroll from "./layout/NavigationScroll";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache, {StylisPlugin} from "@emotion/cache"; 
import { create } from "jss";
import rtl from "jss-rtl";
import {useSelector} from "./store/reducer";
import { MsalAuthenticationTemplate} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import Loader from "./ui-component/extended/Loader/Loader";
import useDetectTabCloseOnly from "./util/browserCloseHook";
import { STORAGE_KEY } from "./views/pending-claims/commonsUtility";

const jss = create({
  plugins: [...jssPreset().plugins, rtl()]
});

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [rtlPlugin as StylisPlugin]
});


 

const  App = () => {
    const customization = useSelector(state => state.customization);
    if (customization?.rtlLayout) {
      const body = document.querySelector("body")
      if(body) body.setAttribute("dir", "rtl");
    }
    useDetectTabCloseOnly(() => {
      console.log('Browser or tab is closed — clearing storage');
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem("userRole");
      localStorage.removeItem("carrierList");
    });
    return (      
        
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            errorComponent={(result) => (
              <section className="login-screen">
                <section className="login-card">
                  <div>{result.error?.message}</div>
                </section>
              </section>
            )}
            loadingComponent={() => (
              <Loader></Loader>
            )}
          >
            <main>
            <StylesProvider jss={jss}>           
              <CacheProvider value={cacheRtl}>
                  <StyledEngineProvider injectFirst>
                      <NavigationScroll>
                        <ThemeProvider theme={theme(customization as Theme)}>
                          <CssBaseline />
                          <Routes />
                          <Snackbar />
                        </ThemeProvider>
                      </NavigationScroll>
                    </StyledEngineProvider>     
              </CacheProvider>              
            </StylesProvider>  
            </main>
          </MsalAuthenticationTemplate>
    );
}


export default App;